import { render, staticRenderFns } from "./PluginUblSettings.vue?vue&type=template&id=38c1d14f"
import script from "./PluginUblSettings.vue?vue&type=script&lang=ts"
export * from "./PluginUblSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c1d14f')) {
      api.createRecord('38c1d14f', component.options)
    } else {
      api.reload('38c1d14f', component.options)
    }
    module.hot.accept("./PluginUblSettings.vue?vue&type=template&id=38c1d14f", function () {
      api.rerender('38c1d14f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/PluginUblSettings.vue"
export default component.exports